<app-top-nav-registration [llttfPage]="llttfpage"></app-top-nav-registration>
<div class="h-30"></div>
<div class="container">
    <div class="content">
        <div class="facility-heading">
            <img src="assets/danger.svg" height="50px"/> Access denied
        </div>
        <div class="designatedFacilityForm">

        <span>
           The link you are trying to access is no longer valid. Please request for a new link.
        </span>
        <br>
        </div>
    </div>
<app-footer></app-footer>
